import { DefaultDirections, SortProviderProps, UrlSortProvider } from '@tableau/data-catalog-shared';
import * as React from 'react';

import { OrderDirection, SheetOrderField } from '../../../../gen-src/queries/globalTypes';

export type SheetsValidSortFields = SheetOrderField.NAME;

export const SheetsDefaultDirections: DefaultDirections<SheetsValidSortFields> = {
  [SheetOrderField.NAME]: OrderDirection.ASC,
};

export const SheetsDefaultSortField = SheetOrderField.NAME;

export function SheetsGridSortProvider(
  props: Pick<SortProviderProps<SheetsValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<SheetsValidSortFields>
      validOrderFieldsWithDefaultDirections={SheetsDefaultDirections}
      defaultField={SheetsDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
